<div class="quiz-container" [formGroup]="quizzesGroup">
  <div class="top-section">
    <div class="title">
      <div class="main-title">Add Quiz</div>
      <div class="sub-title">
        Quizzes will appear at the end of every module.
      </div>
    </div>
    <div class="close-btn" (click)="onClickCancel()">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>

  <div class="quizzes" formArrayName="questions">
    <div
      class="quiz"
      *ngFor="
        let quiz of quizzesGroup.get('questions')['controls'];
        let i = index
      "
      [formGroupName]="i"
    >
      <div class="title">
        <span> Question {{ i + 1 }} </span>
        <i class="fa-solid fa-trash-can" (click)="onRemoveQuiz(i)"></i>
      </div>
      <div class="content">
        <div class="question">
          <textarea
            name=""
            id=""
            [placeholder]="'question 0' + (i + 1)"
            formControlName="question"
            rows="1"
          ></textarea>
        </div>
        <div class="options" formArrayName="options">
          <div
            class="option"
            *ngFor="
              let option of quiz.get('options')['controls'];
              let j = index
            "
          >
            <div class="radio-btn">
              <input
                type="radio"
                [checked]="option.value === quiz.get('answer').value"
                (click)="onClickRadioButton(i, j)"
                [name]="i"
              />
            </div>
            <div class="input-box">
              <input
                [placeholder]="'option 0' + (j + 1)"
                type="text"
                [formControlName]="j"
              />
            </div>
            <div class="add-symbol-btn" (click)="onAddDegreeSymbol(option, j)">
              <span>{{degreeSymbol}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="quiz-btn">
    <button (click)="onAddMoreQuiz()" *ngIf="!isLoading">Add More Quiz</button>
    <button *ngIf="!isUpdate && !isLoading" (click)="addQuiz()">Save</button>
    <button *ngIf="!isUpdate && isLoading">
      Saving
      <i class="fa-solid fa-spinner fa-spin"></i>
    </button>
  </div>
</div>
